import React from 'react';
import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label } from 'cw-ui-core';
import Locale from 'src/i18n';
import css from './CancelApplicationDialog.scss';
import TextButton from 'src/components/TextButton';

export const CANCEL_APPLICATION_DIALOG = 'CANCEL_APPLICATION_DIALOG';

const CancelApplicationDialog = props => {
    const { formatMessage } = props.intl;

    const dialogButtons = [
        <TextButton key="ok" automationName="ok" text={formatMessage(Locale.ok)} onClick={props.onOk} />,
        <TextButton
            key="cancel"
            automationName="cancel"
            text={formatMessage(Locale.cancel)}
            onClick={props.onCancel}
        />,
    ];

    return (
        <Dialog
            dialogId={CANCEL_APPLICATION_DIALOG}
            header={formatMessage(Locale.cancelApplicationCreation)}
            buttons={dialogButtons}>
            <br />
            <div className={css.wrap}>
                <ScreenMessagePanelContainer className={css.screenMessage} screenKey={CANCEL_APPLICATION_DIALOG} />
                <Label>{formatMessage(Locale.cancelApplicationCreationConfirmation)}</Label>
            </div>
        </Dialog>
    );
};

export default injectIntl(CancelApplicationDialog);
